export default __webpack_public_path__ + "static/media/dashbaord_X.26805142.svg";